import { render, staticRenderFns } from "./ScreenshotModal.vue?vue&type=template&id=b4f327b0&scoped=true&"
import script from "./ScreenshotModal.vue?vue&type=script&lang=js&"
export * from "./ScreenshotModal.vue?vue&type=script&lang=js&"
import style0 from "./ScreenshotModal.vue?vue&type=style&index=0&id=b4f327b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4f327b0",
  null
  
)

export default component.exports